/**
 * Temporary-password + email helpers shared by every create-user surface.
 *
 * Both the header's "Add new user" modal and the hours editor's "Quick Add
 * User" modal hand a brand-new account a temporary password and show it to
 * the creator before the welcome email goes out. They had to agree on what
 * that password looks like and on what counts as an email address, so the
 * helpers live here instead of being retyped in each modal.
 */

/* ------------------------------------------------------------------ *
 * Friendly temporary password generator
 * Produces memorable, easy-to-type passwords like "Brave-Otter-7392":
 * two capitalized words + a 4-digit number joined by hyphens. Mixed case,
 * digits and the hyphen keep it inside the password policy
 * (utils/validatePassword), and the user is forced to change it on first
 * sign-in anyway.
 * ------------------------------------------------------------------ */
const PW_ADJECTIVES = ['Brave', 'Bright', 'Calm', 'Clever', 'Eager', 'Happy', 'Kind', 'Lucky', 'Nimble', 'Proud', 'Quick', 'Sunny', 'Swift', 'Witty', 'Bold'];
const PW_NOUNS = ['Otter', 'Falcon', 'Maple', 'River', 'Tiger', 'Comet', 'Harbor', 'Meadow', 'Canyon', 'Willow', 'Badger', 'Cedar', 'Heron', 'Pine', 'Raven'];

/** A fresh human-friendly temporary password, e.g. "Brave-Otter-7392". */
export function generateTempPassword(): string {
	const adjective = PW_ADJECTIVES[Math.floor(Math.random() * PW_ADJECTIVES.length)];
	const noun = PW_NOUNS[Math.floor(Math.random() * PW_NOUNS.length)];
	const number = Math.floor(1000 + Math.random() * 9000);
	return `${adjective}-${noun}-${number}`;
}

/** Basic email shape check — the backend remains the source of truth. */
export function isValidEmail(email: string): boolean {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
